import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import { useWindowResize } from "@/utils/useWindowSize";
import BaseModal from "@/components-UI/modals/BaseModal.vue";
import BaseSelect from "@/components-UI/BaseSelect.vue";
import BaseAutocomplete from "@/components-UI/BaseAutocomplete.vue";
import BaseInputNumber from "@/components-UI/BaseInputNumber.vue";
import BaseList from "@/components-UI/list/BaseList.vue";
import BaseListItem from "@/components-UI/list/BaseListItem.vue";
import { LimitType, LimitPeriod, INewLimit } from "@/components/offers/offer/individual-limits/types";
import { getAffiliateSearch } from "@/api/user";
import SvgReset from '@/assets/icons/reload.svg';
import SvgCheck from '@/assets/icons/check.svg';
import BaseButtonV2 from "@/components-UI/buttons/BaseButtonV2.vue";

interface IForm {
    affiliate_id: number | null;
    type: LimitType | null;
    period: LimitPeriod | null;
    value: number | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AddLimitModal',
  emits: ["save"],
  setup(__props, { expose, emit }: { emit: ({
    (e: 'save', payload: INewLimit): void;
}), expose: any, slots: any, attrs: any }) {



const affiliateTemplate = (item: { id: number; first_name?: string; last_name?: string }): string =>
    `${item.id} ${item.first_name ?? ''} ${item.last_name ?? ''}`.replace(/\s+/g, ' ').trim();

const typeOptions: { value: LimitType; label: string }[] = [
    { value: 'conversion', label: 'по конверсиям' },
    { value: 'payout', label: 'по выплате' },
    { value: 'revenue', label: 'по доходу' },
];

const periodOptions: { value: LimitPeriod; label: string }[] = [
    { value: 'daily', label: 'в день' },
    { value: 'monthly', label: 'в месяц' },
];

const getEmptyForm = (): IForm => ({
    affiliate_id: null,
    type: null,
    period: null,
    value: null,
});

// На мобильных модалка разворачивается на весь экран (как в дизайне)
const { width } = useWindowResize();
const isFullscreen = computed(() => width.value <= 768);

const isShow = ref(false);
const form = ref<IForm>(getEmptyForm());
// Имя выбранного партнёра — берём из результата поиска, чтобы показать в таблице
const affiliateName = ref('');

// При очистке BaseAutocomplete эмитит `select` с пустым объектом — item может быть undefined
const onSelectAffiliate = ({ item }: { item?: { first_name?: string; last_name?: string } }): void => {
    affiliateName.value = item
        ? [item.first_name, item.last_name].filter(Boolean).join(' ')
        : '';
};

const onClearAffiliate = (): void => {
    affiliateName.value = '';
};

const isValid = computed(() =>
    form.value.affiliate_id !== null
    && form.value.type !== null
    && form.value.period !== null
    && form.value.value !== null
    && form.value.value > 0,
);

const openModal = () => {
    form.value = getEmptyForm();
    affiliateName.value = '';
    isShow.value = true;
};

const hideModal = () => {
    isShow.value = false;
};

const save = () => {
    if (!isValid.value) return;
    emit('save', {
        affiliate_id: form.value.affiliate_id as number,
        affiliate_name: affiliateName.value,
        type: form.value.type as LimitType,
        period: form.value.period as LimitPeriod,
        value: form.value.value as number,
    });
    hideModal();
};

expose({ openModal });

return { __sfc: true,emit, affiliateTemplate, typeOptions, periodOptions, getEmptyForm, width, isFullscreen, isShow, form, affiliateName, onSelectAffiliate, onClearAffiliate, isValid, openModal, hideModal, save, BaseModal, BaseSelect, BaseAutocomplete, BaseInputNumber, BaseList, BaseListItem, getAffiliateSearch, SvgReset, SvgCheck, BaseButtonV2 }
}

})